export default "__VITE_ASSET__BH5uNpi3__"